<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 9H12C10.8954 9 10 9.89543 10 11V17C10 18.1046 10.8954 19 12 19H18C19.1046 19 20 18.1046 20 17V11C20 9.89543 19.1046 9 18 9Z" stroke="#151515" stroke-width="2" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M8 6H14.5455C15.0977 6 15.5455 6.44772 15.5455 7H17.5455C17.5455 5.34315 16.2023 4 14.5455 4H8C6.34315 4 5 5.34315 5 7V13.5455C5 15.2023 6.34315 16.5455 8 16.5455V14.5455C7.44771 14.5455 7 14.0977 7 13.5455V7C7 6.44772 7.44772 6 8 6Z" fill="#151515" />
  </svg>
</template>
